/* unplugin-vue-components disabled */import { render } from "./eryuanIntro.vue?vue&type=template&id=ecfcf97a&scoped=true"
import script from "./eryuanIntro.vue?vue&type=script&lang=js"
export * from "./eryuanIntro.vue?vue&type=script&lang=js"

import "./eryuanIntro.vue?vue&type=style&index=0&id=ecfcf97a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecfcf97a"]])

export default __exports__